export const COLORS = {
  blue: '#007180',
  grey: '#333',
  white: '#fff',
  red: '#ff0000',
  black: '#000'
}
